const translations = {
  "We're sorry": {
    en: "We're sorry",
    es: 'Lo sentimos',
    pt: 'Desculpe',
  },
  "This video cannot be played right now": {
    en: "This video cannot be played right now",
    es: 'Este video no se puede reproducir en este momento',
    pt: 'Este vídeo não pode ser reproduzido agora',
  },
  'This video is unavailable': {
    en: 'This video is unavailable',
    es: 'Este video no está disponible',
    pt: 'Este vídeo não está disponível',
  },
  "This content is not included in your current plan": {
    en: "This content is not included in your current plan",
    es: 'Este contenido no está incluido en su plan actual',
    pt: 'Este conteúdo não está incluído em seu plano atual',
  },
  'You need to log in to view this content': {
    en: 'You need to log in to view this content',
    es: 'Inicie sesión para ver este contenido',
    pt: 'Faça login para ver este conteúdo',
  },
  'This content has more than one option to watch': {
    en: 'This content has more than one option to watch',
    es: 'Este contenido tiene más de una opción para ver',
    pt: 'Este conteúdo tem mais de uma opção para assistir',
  },
  'Select the audio option you prefer': {
    en: 'Select the audio option you prefer',
    es: 'Seleccione la opción de audio que prefiera',
    pt: 'Selecione a opção de áudio que prefira',
  },
  'Something went wrong': {
    en: 'Something went wrong',
    es: 'Algo salió mal',
    pt: 'Algo deu errado',
  },
  "Your account has exceeded the maximum number of concurrent connections": {
    en: "Your account has exceeded the maximum number of concurrent connections",
    es: 'Su cuenta ha excedido el número máximo de conexiones simultáneas',
    pt: 'Sua conta excedeu o número máximo de conexões simultâneas',
  },
  'Unlock this content': {
    en: 'Unlock this content',
    es: 'Desbloquea este contenido',
    pt: 'Desbloqueie este conteúdo'
  },
  'Select a plan to continue watching': {
    en: 'Select a plan to continue watching',
    es: 'Seleccione un plan para continuar viendo',
    pt: 'Escolha um plano para continuar assistindo'
  },
  'Loading available plans': {
    en: 'Loading available plans',
    es: 'Cargando planes disponibles',
    pt: 'Carregando planos disponíveis'
  },
  'Your payment is past due': {
    en: 'Your payment is past due',
    es: 'Tu pago está vencido',
    pt: 'Seu pagamento está vencido'
  },
  'View my subscription': {
    en: 'View my subscription',
    es: 'Ver mi suscripción',
    pt: 'Ver minha assinatura'
  },
  'Back to live': {
    en: 'Back to live',
    es: 'Regresar al vivo',
    pt: 'Voltar ao vivo'
  },
  'Start over': {
    en: 'Start over',
    es: 'Ver desde el comienzo',
    pt: 'Ver desde o início'
  },
  'Pause': {
    en: 'Pause',
    es: 'Pausar',
    pt: 'Pausar'
  },
  'Seek': {
    en: 'Seek',
    es: 'Buscar en el video',
    pt: 'Buscar no vídeo'
  },
  'Mute': {
    en: 'Mute',
    es: 'Silenciar',
    pt: 'Silenciar'
  },
  'Unmute': {
    en: 'Unmute',
    es: 'Activar sonido',
    pt: 'Ativar som'
  },
  'Volume': {
    en: 'Volume',
    es: 'Volumen',
    pt: 'Volume'
  },
  'Language': {
    en: 'Language',
    es: 'Idioma',
    pt: 'Idioma'
  },
  'Audio': {
    en: 'Audio',
    es: 'Audio',
    pt: 'Áudio'
  },
  'Settings': {
    en: 'Settings',
    es: 'Ajustes',
    pt: 'Configurações'
  },
  'Quality': {
    en: 'Quality',
    es: 'Calidad',
    pt: 'Qualidade'
  },
  'Auto': {
    en: 'Auto',
    es: 'Automática',
    pt: 'Automática'
  },
  'Subtitles': {
    en: 'Subtitles',
    es: 'Subtítulos',
    pt: 'Legendas'
  },
  'Off': {
    en: 'Off',
    es: 'Desactivados',
    pt: 'Desativadas'
  },
  'Cast': {
    en: 'Cast',
    es: 'Transmitir',
    pt: 'Transmitir'
  },
  'Fullscreen': {
    en: 'Fullscreen',
    es: 'Pantalla completa',
    pt: 'Tela cheia'
  },
  'Exit fullscreen': {
    en: 'Exit fullscreen',
    es: 'Salir de pantalla completa',
    pt: 'Sair da tela cheia'
  }
}

export default translations